import StripeCheckout from "./Stripe";

export const GATEWAY_REGISTRY = {
  stripe: StripeCheckout,
  // "2c2p": TwoC2PCheckout,
  // paypal: PayPalCheckout,
};

export const isVendorSupported = (vendor) => {
  const v = String(vendor || "").toLowerCase();
  return Boolean(GATEWAY_REGISTRY[v]);
};
